import Notify from "utils/notify";
import Cookies from "js-cookie";

import { ActionTypes } from "./types";
import { removeAllCookie } from "utils/StorageVariables";
import { deleteAccount } from "api";
import { resetAllState } from "Redux/Global/action";
import { setUserId, track, reset } from 'utils/amplitude';

export const DeleteAccount = id => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });

    const { status } = await deleteAccount(id);

    if (status && status >= 200 && status < 300) {
      dispatch({
        type: ActionTypes.SUCCESS
      });

      // Clear development token if in development mode
      if (process.env.NODE_ENV === 'development')
        Cookies.remove('token-local');

      // Clear cookies
      removeAllCookie();

      // Reset all Redux state
      dispatch(resetAllState());

      // Amplitude
      setUserId(undefined);
      reset();
      track('Account Deleted');

      Notify.success('Account Deleted');
    }
  } catch (error) {
    Notify.error(error, true);

    dispatch({
      type: ActionTypes.ERROR,
      payload: error
    });
  }
};
